import React, { useState } from "react";
import * as Icons from "lucide-react";
import { ChevronDown, Check } from "lucide-react";
import { GUIDE_PARTS, GUIDE_CHAPTERS } from "@/data/guideTdah";

export const partOf = (ch) => GUIDE_PARTS.find((p) => p.id === ch.part);
export const ChapterIcon = ({ name, size = 22, style }) => { const I = Icons[name] || Icons.BookOpen; return <I size={size} style={style} />; };

export default function GuideSommaire({ current, read, onSelect }) {
  const [open, setOpen] = useState(false);
  const cur = GUIDE_CHAPTERS[current];
  const pick = (i) => { onSelect(i); setOpen(false); };
  const list = (
    <nav className="space-y-4" data-testid="guide-sommaire-list">
      {GUIDE_PARTS.map((p) => (
        <div key={p.id}>
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] mb-1.5" style={{ color: p.color }}><span className="w-2.5 h-2.5 rounded-full" style={{ background: p.color }} />{p.title}</div>
          <ul className="space-y-1">
            {GUIDE_CHAPTERS.map((ch, i) => ch.part === p.id && (
              <li key={ch.id}>
                <button onClick={() => pick(i)} data-testid={`guide-toc-${ch.id}`} aria-current={i === current ? "page" : undefined}
                  className={`w-full text-left flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors ${i === current ? "text-white font-bold shadow-sm" : "text-[var(--ink)] hover:bg-white"}`}
                  style={i === current ? { background: p.color } : undefined}>
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 ${i === current ? "bg-white/25" : "g-chip"}`} style={i !== current ? { background: p.soft, color: p.color, "--part": p.color } : undefined}>{read.has(ch.id) && i !== current ? <Check size={13} strokeWidth={3} /> : i + 1}</span>
                  <span className="leading-tight">{ch.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
  return (
    <>
      <aside className="hidden lg:block w-72 shrink-0 no-print"><div className="sticky top-6 rounded-3xl bg-[var(--sand)]/70 border border-[var(--border)] p-4 max-h-[calc(100vh-3rem)] overflow-y-auto" data-testid="guide-sommaire-desktop">{list}</div></aside>
      <div className="lg:hidden no-print" data-testid="guide-sommaire-mobile">
        <button onClick={() => setOpen((v) => !v)} data-testid="guide-sommaire-toggle" aria-expanded={open} className="w-full flex items-center justify-between gap-3 rounded-2xl bg-white border border-[var(--border)] px-4 py-3 text-left shadow-sm">
          <span className="flex items-center gap-2.5 min-w-0"><span className="w-7 h-7 rounded-full text-white text-xs font-bold flex items-center justify-center shrink-0" style={{ background: partOf(cur).color }}>{current + 1}</span><span className="truncate font-semibold text-[var(--ink)]">{cur.title}</span></span>
          <span className="flex items-center gap-1 text-xs text-[var(--ink-soft)] shrink-0">Sommaire <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} /></span>
        </button>
        {open && <div className="mt-2 rounded-3xl bg-[var(--sand)]/80 border border-[var(--border)] p-4 animate-fade-up">{list}</div>}
      </div>
    </>
  );
}
